import React, { useState } from 'react';
import ChangeRolesModal from '../../components/Modal/ChangeRolesModal';
import YesNoModal from '../../components/Modal/YesNoModal';
import { Button } from '../../components/Common';

const UsersTable = ({ users, getUsers, onDeletion, onPasswordReset, onMfaReset, mfaEnforced, roles }) => {
    const [selectedUser, setSelectedUser] = useState();
    const [open, setOpen] = useState(false);

    if (!users) {
        return <p>Loading...</p>;
    }

    return (
        <div className="user-management__user-table">
            <table className="table">
                <colgroup>
                    <col width="20%" />
                    <col width="10%" />
                    <col width="10%" />
                    <col width="30%" />
                    <col width="60%" />
                </colgroup>
                <thead>
                    <tr>
                        <th>Login</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Roles</th>
                        <th>Operations</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(u => (
                        <tr key={u.email}>
                            <td>{u.email}</td>
                            <td>{u.firstname}</td>
                            <td>{u.lastname}</td>
                            <td>
                                <ul className="user-management__user-table--list">
                                    {u.roles.map(label => {
                                        const foundRole = roles.find(role => role.label === label);
                                        return <li key={foundRole.label}>{foundRole.description || foundRole.label}</li>;
                                    })}
                                </ul>
                            </td>
                            <td>
                                <div className="user-management__user-table--operations">
                                    <Button
                                        text="Change Roles"
                                        onClick={() => {
                                            setSelectedUser(u);
                                            setOpen(true);
                                        }}
                                    />
                                    <ChangeRolesModal
                                        email={selectedUser?.email}
                                        allRoles={roles}
                                        userRoles={selectedUser?.roles}
                                        getUsers={getUsers}
                                        open={open}
                                        setOpen={setOpen}
                                    />
                                    <YesNoModal
                                        title={`Reset password for ${u.email}`}
                                        message={'Are you sure you want to reset password for this user?'}
                                        action={() => onPasswordReset(u.email)}
                                        button={'Reset password'}
                                    />
                                    <YesNoModal
                                        title={`Reset MFA for ${u.email}`}
                                        message={
                                            `This removes any authenticator app registered for ${u.email}.` +
                                            // Only when known to be enforced: `undefined` means the
                                            // page never got an answer, and this is where the admin
                                            // decides.
                                            (mfaEnforced === true ? ' They will have to set up a new one the next time they log in.' : '') +
                                            // Said here and not only in the toast: an admin resetting a
                                            // stolen authenticator is deciding whether this contains
                                            // the incident, and on its own it does not. EMU-747.
                                            ' It does not close a portal tab they already have open — that keeps working until its current access token' +
                                            ' expires. Are you sure?'
                                        }
                                        action={() => onMfaReset(u.email)}
                                        button={'Reset MFA'}
                                    />
                                    <YesNoModal
                                        title={`Delete user`}
                                        message={`Are you sure you want to delete user ${u.email}?`}
                                        action={() => onDeletion(u.email)}
                                        button={'Delete'}
                                    />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default UsersTable;
